<template>
  <base-content
    :data="data"
    :index="index"
  >
      <template #card-header>
        <partial-title
          :title="title"
          :link="link"
          :lineClamp="2"
        />
      </template>

      <template #card-body>
        <ul>
          <li class="t-sm">
            <template v-if="foundationYear">
              <span class="t-600">Founded</span>
              <span class="ml-2">{{ foundationYear }}</span>
            </template>
            <template v-else>
              <span><br /></span>
            </template>
          </li>
          <li class="t-overflow t-sm">
            <template v-if="fundingData">
              <span class="t-600">Funding stage</span>
              <span class="ml-2">{{ fundingData }}</span>
            </template>
            <template v-else>
              <span><br /></span>
            </template>
          </li>
          <matches class="mt-1" v-if="!isEmpty(matches)" :matches="matches" />
        </ul>
      </template>

      <template #card-footer>
        <div class="d-flex align-items-center">
          <i class="t-secondary mr-3" :class="renderOrganisationCategoryIcon(data.organisation_types)" />
          <span class="t-overflow">
            {{ industryAndTypeString }}
          </span>
          <span class="ml-2" v-if="data.country">
            <flag :title="renderCountryFlagTooltip(data.country)" :iso="data.country.alpha_2 | lowercase" :squared="false" class="bd-radius" />
          </span>
        </div>
      </template>
      <template #card-actions>
        <slot name="actions"></slot>
      </template>
  </base-content>
</template>

<script>
import processing from '@/mixins/search/results/organisation'

import BaseContent from '@/components/search/results/BaseContent'
import Matches from '@/components/search/results/partials/Matches'
import PartialTitle from '@/components/search/results/partials/Title'

export default {
  name: 'organisationResultBlock',
  mixins: [processing],
  components: {
    Matches,
    PartialTitle,
    BaseContent
  }
}
</script>
